<template>
  <div class="w1200 newsBox">
    <div class="w1200" style="overflow: hidden;background-color: #F9F9F9">
      <div class="leftBox">
        <div class="bannerBox">
          <img :src="banner" alt="">
        </div>
        <div style="min-height: 70vh">
          <div class="pushu_nav">
            <div class="columnBoxInnner">
              <div class="columnBoxInnnerList">
                <div class="bookTitle">
                  人物传记
                </div>
                <span v-for="(item,index) in bookType" :key="index" :class="currentPushu==index?'activenames':'names'" @click="gopushu(item,index)"><span class="span_name">{{ item.DICTIONARY_NAME }}</span><span v-if="index!=bookType.length-1" style="margin: 0 8px;">/</span></span>
                <div class="serchNew">
                  <span class="el-icon-search searchIcon" @click="goSearch" />
                  <input v-model="searchKey" type="text" placeholder="请输入关键字进行搜索">
                </div>
              </div>
            </div>
          </div>
          <div class="serchNew2">
            <span class="el-icon-search searchIcon" @click="goSearch" />
            <input v-model="searchKey" type="text" placeholder="请输入关键字进行搜索">
          </div>
          <div v-show="allbookData.length>0" class="showlist">
            <div v-for="(item,index) in allbookData" :key="index" class="lilist">
              <a :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank" class="phoneShow" />
              <div :class="item.COVER?'right_div':'right_div_no'">
                <p style="height: 20px;line-height: 20px;overflow: hidden;">
                  <span v-if="item.SHOW_IS_TOP=='1'" style="display: inline-block;width: 40px; height: 20px;line-height: 20px;background-color: #CC0000;color: #ffffff;font-size: 14px;border-radius: 5px;text-align: center;margin-right: 20px">置顶</span>
                  <span class="titleSvg">
                    <svg-icon icon-class="nodeicon" />
                  </span>
                  <a style="cursor: pointer;font-weight: 600;font-size: 16px" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">{{ item.SHOW_TITLE }}—{{ item.TREE_NAME }}</a>
                </p>
                <p class="puxi_content" style="font-size: 12px;">
                  {{ item.SHOW_ABSTRACT }}
                </p>
                <div class="puxi_foot">
                  <div class="msguser">
                    <img :src="item.USER_PHOTO" alt="">
                  </div>
                  <span class="msgUsername">{{ item.USER_NAME }}</span>
                  <span class="times">{{ item.CREATE_DATE }}</span>
                  <span class="readSize el-icon-view">   {{ item.SHOW_READ_SIZE }}</span>
                  <span class="collectionSize el-icon-star-on ">   {{ item.CONTENT_COLLECTION_NUMBER }}</span>
                  <span class="speckSize"><svg-icon icon-class="pinlun" />  {{ item.CONTENT_SPEAK_NUMBER }}</span>
                </div>
              </div>
              <a :class="item.COVER?'imgBox':'noimg'" :href="'/sourceView?sourceId='+item.SHOW_RES_ID+'&type='+item.SHOW_TYPE" target="_blank">
                <img v-if="item.COVER" :src="item.COVER" alt="">
              </a>
              <div class="tip">
                {{ item.DICTIONARY_NAME }}
              </div>
            </div>
          </div>
          <div v-show="allbookData.length<=0" style="text-align: center;font-size: 20px;color: #a19d9e;font-weight: 600;background-color: #ffffff;height: 150px;line-height: 150px;">
            暂无数据
          </div>
          <div class="addMore" @click="addMore">
            <span v-show="!loadAll" class="addMore_span">
              <span v-show="!isloading">加载更多</span>
              <span v-show="isloading" class="el-icon-loading" style="font-size: 16px" />
            </span>
            <span v-show="loadAll">已经到底了</span>
          </div>
        </div>
      </div>
      <div class="rightBox">
        <Rightlist />
      </div>
    </div>
    <!--<div>2</div>-->
  </div>
</template>
<script>
import Rightlist from '@/components/commonRightList'
import { getClassz, getdataNodeList } from '@/api/api.js'
export default {
  components: { Rightlist },
  head() {
    // var listObj = this.$store.state.hotList_home
    var metaStr = ''
    // listObj.forEach(a => {
    //   metaStr += a.CONTENT_TITLE + ' | '
    // })
    return {
      title: '人物传记-中国人物_历史人物_家族始祖_先祖_家族名人,历史伟人-彭祖世家网',
      mateDesc: '这里有历史先贤,家族名人,先祖家族,古代名人家谱,古代名人轶事,名人家谱,名人家谱繁衍。昨日看历史伟人论家谱,今日寻根问祖,告慰先贤。',
      keys: '人物,始祖,祖先,历史人物,修谱人,人物传记,门第,名门望族'
    }
  },
  data() {
    return {
      isloading: false,
      searchKey: '',
      currerntPage: 1,
      currentType: '',
      loadAll: false,
      bookData: [],
      bookType: [{ DICTIONARY_ID: '', DICTIONARY_NAME: '全部' }],
      currentPushu: 0,
      pushu: require('@/static/renwu.png'),
      banner: require('@/static/renwu_banner.png'),
      noIMG: require('@/static/usuerDefault.png'),
      keys: '',
      logo: require('@/static/search_logo_peng.png'),
      currentIndex: 0,
      islogin: false,
      username: '',
      userData: {},
      arrs: [{ 'name': '账号设置' }, { 'name': '我的收藏' }, { 'name': '我的评论' }, { 'name': '我的消息' }, { 'name': '退出登录' }],
      banner_foot: require('@/static/banner_foot.png')
    }
  },
  computed: {
    allbookData() {
      if (this.$store.state.renwuList) {
        return this.$store.state.renwuList
      } else {
        return []
      }
    }
  },
  asyncData({ store, route }) {
    var obj = {
      page: 1,
      limit: 12
    }
    return store.dispatch('getdataNodeList', obj)
  },
  mounted() {
    // //回车搜索事件
    const that = this
    document.onkeypress = function(e) {
      var keycode = document.all ? event.keyCode : e.which
      if (keycode == 13) {
        that.goSearch()
        return false
      }
    }
    this.fn()
    this.initType()
  },
  methods: {
    fn: function() {
      window.scrollTo(0, 0)
    },
    // /查询字典
    initType() {
      getClassz({ classCode: 'nodeType' }).then(res => {
        this.bookType = this.bookType.concat(res.data)
        // console.log(res.data)
        for (let i = 0; i < this.bookType.length; i++) {
          if (this.bookType[i].DICTIONARY_ID == this.$route.query.classz) {
            this.currentPushu = i
          }
        }
      })
    },
    initData() {
      var obj = {
        page: 1,
        limit: 12,
        systemCode: this.systemConfig.systemConfig.sytemName
      }
      if (this.$route.query.classz) {
        obj.type = this.$route.query.classz
      }
      getdataNodeList(obj).then(res => {
        // console.log(res.data)
        this.bookData = res.data.listMapData
        var str = /^http/
        for (var i = 0; i < this.bookData.length; i++) {
          if (!str.test(this.bookData[i].COVER)) {
            this.bookData[i].COVER = ''
          }
        }
        if (res.data.count <= 6) {
          this.loadAll = true
        }
      })
    },
    gopushu(names, index) {
      this.loadAll = false
      this.currerntPage = 1
      this.currentType = names.DICTIONARY_ID
      getdataNodeList({ str: this.searchKey, page: 1, limit: 12, type: names.DICTIONARY_ID, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = res.data.listMapData
        this.$store.commit('setdataNodeList', res.data.listMapData)
        // var str = /^http/
        // for (var i = 0; i < this.bookData.length; i++) {
        //   if (!str.test(this.bookData[i].COVER)) {
        //     this.bookData[i].COVER = ''
        //   }
        // }
        if (res.data.count <= 12) {
          this.loadAll = true
        }
      })
      this.currentPushu = index
      if (this.$route.query.classz) {
        this.$router.replace('/nodeList')
      }
    },
    addMore() {
      this.isloading = true
      this.bookData = this.$store.state.renwuList
      this.currerntPage++
      getdataNodeList({ str: this.searchKey, page: this.currerntPage, limit: 12, type: this.currentType, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        var newdata = res.data.listMapData
        // var str = /^http/
        // for (var i = 0; i < newdata.length; i++) {
        //   if (!str.test(newdata[i].COVER)) {
        //     newdata[i].COVER = ''
        //   }
        // }
        this.bookData = this.bookData.concat(newdata)
        this.$store.commit('setdataNodeList', this.bookData)
        setTimeout(() => {
          this.isloading = false
        }, 300)
        if (res.data.page <= this.currerntPage) {
          this.loadAll = true
        }
      })
    },
    goDetail(sourceId, type) {
      const { href } = this.$router.resolve({
        url: '/sourceView',
        name: 'sourceView',
        query: {
          sourceId,
          type
        }
      })
      window.open(href, '_blank')
    },
    goSearch: function() {
      this.bookData = this.$store.state.bookList
      this.currerntPage = 1
      getdataNodeList({ str: this.searchKey, page: this.currerntPage, limit: 12, type: this.currentType, systemCode: this.systemConfig.systemConfig.sytemName }).then(res => {
        this.bookData = this.bookData.concat(res.data.listMapData)
        this.$store.commit('setdataNodeList', this.bookData)
        if (res.data.page <= this.currerntPage) {
          this.loadAll = true
        }
      })
    }
  }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
  .columnBoxInnnerList{
    text-align: left;
  }
  .bookTitle{
    display: inline-block;
    height: 20px;
    line-height: 20px;
    border-left: 2px solid #ed4040;
    padding-left: 10px;
    font-size: 18px;
    margin-left: 20px;
    font-weight: 600;
    margin-right: 20px;
  }

  .serchNew{
    vertical-align: top;
    height: 38px;
    width: 390px;
    border: 1px solid #E3003A;
    display: inline-block;
    position: relative;
    margin-bottom: 20px;
    float: right;
    margin-right: 20px;
    margin-top: 11px;
    .searchIcon{
      cursor: pointer;
      display: inline-block;
      position: absolute;
      top: 0;
      left: 330px;
      height: 38px;
      width: 65px;
      text-align: center;
      line-height: 38px;
      color: #E3003A;
      vertical-align: top;
      font-size: 20px;
    }
    input{
      height: 38px;
      width: 330px;
      position: absolute;
      left: 0;
      top: 0;
      text-indent: 8px;
    }
    .searchBtn{
      display: inline-block;
      position: absolute;
      right: 0;
      top: -1px;
      width: 125px;
      height: 39px;
      text-align: center;
      line-height: 38px;
      background-color: #E3003A;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .serchNew2{
    display: none;
  }

  .phoneShow{
    display: block;
    width: 100%;
    height: 100%;
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
  }
  .noimg{
    display: none;
  }
  .titleSvg{
    svg{
      font-size: 20px;
      color: #E3003A;
      margin-right: 10px;
    }
  }
  .phoneShow{
    display: block;
    width: 100%;
    height: 100%;
    background-color: transparent;
    position: absolute;
    top: 0;
    left: 0;
  }
  .right_div{
    display: inline-block;
    width:660px;
    height: 100px;
    vertical-align: top;
    .readSize{
      display: inline-block;
      width: 80px;
      margin-left: 112px;
      text-align: right;
    }
  }
  .right_div_no{
    display: inline-block;
    width: 100%;
    height: 100px;
    vertical-align: top;
    .readSize{
      display: inline-block;
      width: 80px;
      margin-left: 291px;
      text-align: right;
    }
  }
  .speckSize{
    display: inline-block;
    width: 80px;
    text-align: right;
  }
  .collectionSize{
    width: 80px;
    display: inline-block;
    text-align: right;
  }
  .puxi_foot{
    overflow: hidden;
    color: #b2b2b2;
    margin-top: 5px;
    .msguser{
      display: inline-block;
      width: 25px;
      height: 25px;
      vertical-align: middle;
      img{
        width: 25px;
        height: 25px;
        border-radius: 50%;
      }
    }
    .msgUsername{
      display: inline-block;
      font-size: 14px;
      margin-left: 5px;
      margin-right: 10px;
      width: 110px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      vertical-align: middle;
    }
  }
  .times{
    margin: 0;
    padding: 0;
    font-size: 14px;
    margin-left: 20px;
  }
  .types{
    display: inline-block;
    width: 40px;
    height: 18px;
    border: 1px solid #ed4040;
    text-align: center;
    line-height: 18px;
    color: #ed4040;
    border-radius: 3px;
    font-size: 12px;
  }
  .puxi_content{
    margin-top: 10px;
    height: 40px;
    line-height: 20px;
    font-size: 12px;
    color: #666666;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  ///列表样式
  .pushu_nav{
    overflow: hidden;
    text-align: center;
    background-color: #fff;
    height: 60px;
    line-height: 60px;
    margin-top: 20px;
    margin-bottom: 20px;
    span{
      font-size: 15px;
      color: #333333;
    }
    .names{
      .span_name{
        cursor: pointer;
        color: #333333;
        font-weight: 600;
        font-size: 16px;
      }
    }
    .activenames{
      .span_name{
        cursor: pointer;
        color: #E3003A;
        font-weight: 600;
        font-size: 16px;
      }
    }
  }
  .showlist{
    width: 100%;
    font-size: 0;
    padding-bottom: 20px;
    .lilist{
      background-color: #fff;
      padding:20px 20px;
      margin-bottom: 20px;
      position: relative;
      display: inline-block;
      width: 840px;
      overflow: hidden;
      .imgBox{
        display: inline-block;
        width: 150px;
        height: 100px;
        overflow: hidden;
        margin-left: 30px;
        img{
          width: 150px;
          height:100%;
          cursor: pointer;
        }
      }
      .imgBox_no{
        display: inline-block;
        width: 200px;
        height: 100px;
        overflow: hidden;
        display: none;
        img{
          width: 200px;
          height: 145px;
          cursor: pointer;
        }
      }
      p{
        color: #333333;
        font-size: 15px;
        padding-left: 3px;
      }
      .tip{
        position: absolute;
        top: 25px;
        left: 9px;
        display: inline-block;
        width: 60px;
        background-color:rgba(0,0,0,.3);
        color: #ffffff;
        height: 20px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
        border-radius: 2px;
        cursor: pointer;
        display: none;
        &:hover{
          color: #ed4040;
        }
      }
    }
  }
  .addMore{
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #999999;
    background-color: #fff;
    border: 1px solid #e5e5e5;
    border-radius: 3px;
    cursor: pointer;
    display: inline-block;
    width: 100%;
    margin-top: 20px;
    transition: 0.5s;
    text-align: center;
    margin-bottom: 60px;
    .addMore_span{
      cursor: pointer;
    }
    &:hover{
      border: 1px solid #E3003A;
      color: #E3003A;
    }
  }
  .firstcolumn_tip{
    margin-top: 20px;
    height: 68px;
    border: 1px solid #f0f0f0;
    text-align: center;
    line-height: 68px;
    background-color: #fff;
    font-size: 24px;
    color: #353535;
    font-weight: 600;
    img{
      width:auto;
      height: 29px;
      margin-top: 20px;
    }
  }
  .leftBox{
    width: 880px;
    margin-right: 20px;
    margin-top: 20px;
    float: left;
    .bannerBox{
      width: 880px;
      height: 340px;
      font-size: 0;
      img{
        width:100%;
        height: 340px;
      }
    }
  }
  .rightBox{
    width: 300px;
    margin-top: 20px;
    float: right;
    overflow: hidden;
  }
  .newsBox {
    position: relative;
    width: 100%;
    background-color: #F9F9F9;
    .top {
      position: absolute;
      top: 0;
      width: 100%;
      height: 140px;
      top: -180px;
      z-index: 9;
      background-color: #fff;
      .navs {
        height: 40px;
        background-color: #7e6b5a;
        width: 100%;
        .w1200s {
          width: 1200px;
          height: 40px;
          background-color: #7e6b5a;
          margin: 0 auto;
          position: relative;
          .head-ul {
            display: inline-block;
            overflow: hidden;
            height: 40px;
            background-color: #7e6b5a;
            li {
              display: inline-block;
              margin-top: 10px;
              a {
                padding: 5px 14px;
                margin: 0 5px;
                cursor: pointer;
                color: #ffffff;
              }
            }
          }
          .right_box {
            display: inline-block;
            float: right;
            .login_register {
              border-radius: 5px;
              float: right;
              width: 88px;
              height: 28px;
              margin: 5px 20px;
              line-height: 28px;
              /*border: 1px solid #ed4040;*/
              a {
                display: inline-block;
                width: 42px;
                text-align: center;
                height: 16px;
                margin-top: 6px;
                font-size: 12px;
                line-height: 16px;
                color: #ffffff;
              }
            }
            .login_register a:nth-of-type(1) {
              border-right: 1px solid #fff;
            }
            .userBox {
              border-radius: 5px;
              width: 90px;
              height: 30px;
              margin: 5px 20px;
              line-height: 30px;
              transition: 0.5s;
              position: absolute;
              z-index: 5;
              right: 0;
              top: 0;
              overflow: hidden;
              &:hover {
                height: 240px;
              }
              .imgBox {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: inline-block;
                background-color: #e6e6e6;
                vertical-align: top;
                cursor: pointer;
                font-size: 0;
                img {
                  width: 30px;
                  height: 30px;
                  border-radius: 50%;
                }
              }
              .usercontent {
                width: 150px;
                display: inline-block;
                height: 30px;
                font-size: 12px;
                color: #ffffff;
                /*overflow: hidden;*/
                margin-left: 5px;
                cursor: pointer;
                position: absolute;
                z-index: 6;
              }
              .list {
                margin-top: 10px;
                background-color: #fff;
                li {
                  text-align: center;
                  height: 36px;
                  line-height: 36px;
                  font-size: 12px;
                  cursor: pointer;
                  &:hover {
                    background-color: #ed4040;
                  }
                }
              }
            }
          }
        }
      }
      .logoBox {
        width: 444px;
        height: 60px;
        font-size: 0;
        display: inline-block;
        cursor: pointer;
        margin-top: 40px;
        vertical-align: top;
        img {
          width: 444px;
          height: 60px;
        }
      }
      .searchbox {
        display: inline-block;
        overflow: hidden;
        float: right;
        margin-top: 45px;
        span {
          display: inline-block;
          height: 38px;
          width: 98px;
          border: 1px solid #7e6b5a;
          vertical-align: top;
          text-align: center;
          line-height: 40px;
        }
        .keys_input {
          height: 38px;
          width: 313px;
          border-top: 1px solid #7e6b5a;
          border-bottom: 1px solid #7e6b5a;
          border-left: 1px solid #7e6b5a;
          padding-left: 5px;
          vertical-align: top;
        }
        .btn {
          display: inline-block;
          background-color: #7e6b5a;
          color: #ffffff;
          line-height: 40px;
          height: 40px;
          text-align: center;
          width: 101px;
          cursor: pointer;
        }
      }
      .bannerbox {
        width: 100%;
        height: 500px;
        font-size: 0;
        margin-top: 40px;
        position: relative;
        background-position: center center;
        background-size: auto 100%;
        img {
          width: 100%;
          height: 500px;
        }
        .numberCount {
          position: absolute;
          top: 332px;
          width: 100%;
          text-align: center;
          color: #bb955b;
          font-family: '微软宋体';
        }
      }
    }
  }
</style>
<!--手机端样式-->
<style rel="stylesheet/scss" lang="scss" scoped>
  @media screen and (max-width: 750px) {
    .serchNew2{
      vertical-align: top;
      height: 33px;
      width: 80%;
      border: 1px solid #E3003A;
      display: inline-block;
      position: relative;
      margin-bottom: 20px;
      margin-left: 10%;
      margin-top: 11px;
      border-radius: 23px;
      .searchIcon{
        cursor: pointer;
        display: inline-block;
        position: absolute;
        top: 0;
        left: 250px;
        height: 35px;
        width: 15%;
        text-align: center;
        line-height: 35px;
        color: #E3003A;
        vertical-align: top;
        font-size: 20px;
      }
      input{
        height: 35px;
        width: 75%;
        position: absolute;
        left: 15px;
        top: 0;
      }
    }
    .bookTitle{
      margin-left: 0;
    }
    .serchNew{
      width: 100%;
      display: none;
    }

    .phoneShow{
      display: block;
      width: 100%;
      height: 100%;
      background-color: transparent;
      position: absolute;
      top: 0;
      left: 0;
    }
    .showlist{
      padding: 0 20px;
      padding-bottom: 20px;
      width: auto;
      background-color: #fff;
    }
    .right_div_no .readSize{
      margin-left: 0px;
      text-align: right;
      width: 62px;
      margin-top: 10px;
      font-size: 12px;
    }
    .collectionSize{
      text-align: right;
      width: 81px;
      margin-top: 10px;
      font-size: 12px;
    }
    .speckSize{
      text-align: left;
      width: 70px;
      margin-top: 10px;
      display: none;
    }
    .top{
      display: none;
    }
    .leftBox{
      width: 100%;
      margin-top: 0;
      .bannerBox{
        width: 100%;
        height: auto;
        img{
          width: 100%;
          height: auto;
        }
      }
      .firstcolumn_tip{
        width: 100%;
        height: auto;
        background-color: #fff;
        text-align: center;
        img{
          width: 90%;
          height: auto;
        }
      }
      .columnBoxInnnerList{
        white-space: nowrap;
        padding: 0 20px;
      }
      .pushu_nav{
        width: 100%;
        overflow: hidden;
        overflow-x: auto;
        span{
          float: none;
          margin: 0 auto 20px;
        }
      }
      .lilist{
        width: 100%;
        margin-left: 0;
        border-bottom: 1px solid #eee;
        margin-bottom: 0;
        margin-top: 0;
        padding: 10px 0;
        .tip{
          display: none;
        }
        .right_div{
          width: 70%!important;
          float: left;
          height: 100px;
          overflow: hidden;
          margin: 0;
          .puxi_foot{
            white-space: nowrap;
            margin-top: 2px;
            .readSize{
              margin-left: 0;
              font-size: 12px;
            }
            .times{
              display: none;
            }
            .collectionSize{
              display: none;
            }
          }
        }
        .right_div_no{
          width: 100%!important;
          float: left;
          height: 100px;
          overflow: hidden;
          margin: 0;
          .puxi_foot{
            white-space: nowrap;
          }
        }
        .imgBox{
          width: 30%;
          float: right;
          height: 100px;
          overflow: hidden;
          margin-left: 0;
          img{
            height: 100px;
            width: auto;
          }
        }
        .imgBox_no{
          display: none;
        }
      }
    }
    .rightBox{
      display: none;
    }
    .times{
      margin-left: 3px;
      font-size: 12px;
    }
    .showlist .lilist p{
      margin-top: 3px;
    }
  }
</style>

